import PropTypes from "prop-types";
import React from "react";
import { useMemo, useState, useRef,useEffect } from "react"
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import MenuCart from "./sub-components/MenuCart";
import { deleteFromCart } from "../../redux/actions/cartActions";
import { useAuth } from "../../contexts/AuthContext"
import { multilanguage } from "redux-multilanguage";
import { addToWishlist } from "../../redux/actions/wishlistActions";
import { deleteAllFromWishlist } from "../../redux/actions/wishlistActions";
import  CategoryTab from "../../wrappers/category/CategoryTab";
import { getDiscountPrice } from "../../helpers/product";
import { transformFilename } from "../../helpers/imgfilename";
const IconGroup = ({
  strings,
  products,
  currency,
  cartData,
  wishlistData,
  enquiryData,
  deleteFromCart,
  iconWhiteClass,
  currentLanguageCode,
 // addToWishlist,
 // deleteAllFromWishlist
}) => {

  const {currentUser} = useAuth()
  const history = useHistory()
  const websize="-websize"
  const [query, setQuery] = useState("zzzzzz");
  const inputRef = useRef(null)
  const [isFocused, setIsFocused] = useState(false);
  const [searchHistory,setSearchHistory] = useState([]);
  const divRef=useRef(null);
  const cartRef=useRef(null);
  const [cartlength, setCartLength] = useState(cartData?.length);

  useEffect(() => {  
      if (cartlength>0 && cartlength!=cartData?.length) {
      const cartIcon = document.querySelector('.icon-cart');
      cartIcon.classList.add('bounce');
      setTimeout(() => {
       cartIcon.classList.remove('bounce');
      }, 1000);
      const cartIconm = document.querySelector('.icon-cartm');
      cartIconm.classList.add('bounce');
      setTimeout(() => {
       cartIconm.classList.remove('bounce');
      }, 1000);

    }
  },[cartData])
  
  useEffect(() => {
    const handleClickOutside= (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
      //  console.log('clicked outside')
        setIsFocused(false)
      }
      if (cartRef.current && !cartRef.current.contains(event.target)) {
        const cartContent = document.querySelector(
          ".shopping-cart-content"
        );
        cartContent.classList.remove("active");
      }
    };
 /*   const handleEscapeKey = (event) => {
      if (event.key==='Escape') {
      //  console.log('escape key pressed');
        setIsFocused(false)
      } 
    }; */    
    document.addEventListener('mousedown', handleClickOutside);
  //  document.addEventListener('keydown',handleEscapeKey);
    return () => {
      document.removeEventListener('mousedown',handleClickOutside);
   //   document.removeEventListener('keydown',handleEscapeKey);
    };

  },[]);


   useEffect(() => {
    const storedHistory = localStorage.getItem('searchHistory');
    if (storedHistory){
      setSearchHistory(JSON.parse(storedHistory));
    }
  },[])
   
  const updateSearchHistory = (searchTerm) => {
    const historySet = new Set(searchHistory);
    historySet.add(searchTerm);
    const updatedHistory = Array.from(historySet).slice(0,20);
    setSearchHistory(updatedHistory);
    localStorage.setItem("searchHistory",JSON.stringify(updatedHistory)); 
  }

  const handleClick = e => {
    e.currentTarget.nextSibling.classList.toggle("active");
  }
  
  const handleUserClick = e => {
   e.preventDefault(); 
   if (currentUser==null)
    history.push("/login");
   else 
    history.push("/account");
  };

  const handleClearText = e => {
    if (inputRef.current) {
      inputRef.current.value='';
    }
    setQuery("");
  }


  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };

  const filteredItems = useMemo(() => {
  //   console.log(query.toLowerCase())
  //   console.log(products)
       return products.filter(product => {
       return (product.name.toLowerCase().includes(query.toLowerCase()) ||
        product.nameen.toLowerCase().includes(query.toLowerCase()) ||
        product.id.toLowerCase().includes(query.toLowerCase()) ) &&
        product.visible  && query.length>0
    }) 
   }, [products,query]);
 
   const handleSearchClick = (e) => {
     updateSearchHistory(inputRef.current.value)
     setIsFocused(false)
      setQuery("zzzzzz");
  };

  const handlefilterClick = (e) => {
    updateSearchHistory(inputRef.current.value)
  }
  
  const handleInputChange = (e) => {
   //console.log(e.target.value);
   setQuery(e.target.value)
   // e.setState({type:"name",content: e.target.value})
  }

  const handleFocus =() => {
 //   console.log("setfocus")
    setIsFocused(true)
  }

  const handleHistoryClick = (item) => {
   // console.log(item)
    //console.log(inputRef.current.value)
    inputRef.current.value=item;
    setQuery(item)

  }

  const clearHistoryClick = () => {
    localStorage.removeItem('searchHistory');
    setSearchHistory([]);
  }

  const mapObj = {
    '\/': "2~F",
    '#': "2~H",
  }
  let discountedPrice=0;
  let finalProductPrice=0;
  let finalDiscountedPrice=0;
  
  return (
    <div className="row">
     <div className="col-xl-6 col-lg-6 col-md-5 col-6">
   <div
      className={`header-search-wrap ${iconWhiteClass ? iconWhiteClass : ""}`} 
    >
    <div ref={divRef} className="same-style header-searchBox">
    <div className="search-content form">
    <form action="#" >
      <input style={{ fontSize: '16px' }}
        ref={inputRef} type="text" 
        onFocus={e => handleFocus(e)}
        placeholder={strings["search"]} onChange={e => handleInputChange(e)} />
       {query!=='zzzzzz' && query!==''?
       <span className="left-pan" onClick={e => handleClearText(e)}><i className="fa fa-remove"></i></span>      
       :       
       ""
       }         
       { query!=='zzzzzz' && query!=='' ?        
       <Link className="formbutton" to={{
        pathname: "/shop/"+query,
        state: {type: "name", content: query, offset: 0}
      }}>
      <button  type="submit" 
       onClick={e => handleSearchClick(e)}  
      >Search</button>
      </Link>
      :             
       <button className="buttonDisabled" type="submit" disabled >Search</button>
      }
    </form>
    <div className="searchBox">
    { query!=='zzzzzz' && query!=='' ? 
         <ul>
       { filteredItems.map((single, key) => (              
          discountedPrice = getDiscountPrice(single.price, single.discount),
          finalProductPrice = +(single.price * currency.currencyRate).toFixed(1),
          finalDiscountedPrice = +(
          discountedPrice * currency.currencyRate
         ).toFixed(1),
        <Link key= {key} to={process.env.PUBLIC_URL + "/product/"+single.id.replace(/\/|#/gi, function(matched) {
          return mapObj[matched];
         })
        }> 
        <li onClick={handlefilterClick}>                     
          <div className="searchBox-img" >
              <img
                alt=""
                src={process.env.REACT_APP_MEDIAURL + "/"+ transformFilename(single.image[0], websize)}
                className="img-fluid"
                onError={(e) =>{
                  e.target.src='/assets/img/no-image.png'
                }}
              />
          </div>
          <div className="searchBox-title">
            <h3>
                {" "}
                {currentLanguageCode==='zh'?single.name:single.nameen}{" "}
            </h3>             
          </div>              
          <div className="product-price">
              {discountedPrice !== null ? (
                <div>
                  <span className="discount-price">{currency.currencySymbol + finalDiscountedPrice}
                 { 
                  single.unit[0].id===single.id && currentLanguageCode==='zh' ?
                  (<span className="perunit">/{single.unit[0].name}</span> )
                  :
                  single.unit[0].id===single.id && currentLanguageCode==='en' ? 
                  (<span className="perunit">/{single.unit[0].namee}</span>)
                  : 
                  single.unit[1].id===single.id && currentLanguageCode==='zh' ?
                  (<span className="perunit">/{single.unit[1].name}</span> )
                  :
                  single.unit[1].id===single.id && currentLanguageCode==='en' ? 
                  (<span className="perunit">/{single.unit[1].namee}</span>)
                  : 
                  single.unit[2].id===single.id && currentLanguageCode==='zh' ?
                  (<span className="perunit">/{single.unit[2].name}</span> )
                  :
                  <span className="perunit">/{single.unit[0].namee}</span>                                  
                 }                                                            
                 </span>            
                </div> 
              ) : (
                <span>{currency.currencySymbol + finalProductPrice.toLocaleString()}
                 { 
                  single.unit[0].id===single.id && currentLanguageCode==='zh' ?
                  (<span className="perunit">/{single.unit[0].name}</span> )
                  :
                  single.unit[0].id===single.id && currentLanguageCode==='en' ? 
                  (<span className="perunit">/{single.unit[0].namee}</span>)
                  : 
                  single.unit[1].id===single.id && currentLanguageCode==='zh' ?
                  (<span className="perunit">/{single.unit[1].name}</span> )
                  :
                  single.unit[1].id===single.id && currentLanguageCode==='en' ? 
                  (<span className="perunit">/{single.unit[1].namee}</span>)
                  : 
                  single.unit[2].id===single.id && currentLanguageCode==='zh' ?
                  (<span className="perunit">/{single.unit[2].name}</span> )
                  :
                  <span className="perunit">/{single.unit[0].namee}</span>                                  
                 }                                                            
                 </span>               
              )}
            </div>  
          </li>
          </Link>                 
          )
         )} 
        </ul> 
      : 
      isFocused===true ?
      <ul>       
      { searchHistory.reverse().map((item, index) => (
        <li className="search-history" key={index} 
         onClick={() => handleHistoryClick(item.toString()) }
        >
          {item}</li>
      ))} 
      {
        searchHistory.length>0?
        <li className="clear-search-history"
         onClick={()=> clearHistoryClick()}
        >{strings["clear_search_history"]}</li>
        :
        ""
      }
      </ul> 
      :
      ""               
      }
    </div>
    </div>
    </div>
    </div>
    </div>
    <div className="col-xl-6 col-lg-6 col-md-7 col-6">
    <div className={`header-right-wrap ${iconWhiteClass ? iconWhiteClass : ""}`} 
      >

     <div className="same-style header-enquiry" >
      <Link to={process.env.PUBLIC_URL + "/enquiry"}>
        <i className="pe-7s-chat" />
        <span className="count-style">
          {enquiryData && enquiryData.length ? enquiryData.length : 0}
        </span>
        <span className="title-style">{strings["enquiry"]}</span>
      </Link>
    </div>     
      <div className="same-style header-wishlist" >
        <Link to={process.env.PUBLIC_URL + "/wishlist"}>
          <i className="pe-7s-like" />
          <span className="count-style">
            {wishlistData && wishlistData.length ? wishlistData.length : 0}
          </span>
          <span className="title-style">{strings["wishlist"]}</span>
        </Link>
      </div>
      <div ref={cartRef} className="same-style cart-wrap d-none d-lg-block">
        <button className="icon-cartm" onClick={e => handleClick(e)}>
          <i className="pe-7s-cart" />
          <span className="count-style">
            {cartData && cartData.length ? cartData.length : 0}
          </span>
          <span className="title-style">{strings["cart"]} </span>
        </button>
        {/* menu cart */}
        <MenuCart
          cartData={cartData}
          currency={currency}
          deleteFromCart={deleteFromCart}
        />
      </div>
      <div className="same-style cart-wrap d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
          <i className="pe-7s-cart" />
          <span className="count-style">
            {cartData && cartData.length ? cartData.length : 0}
          </span>
          <span className="title-style">{strings["cart"]}</span>
        </Link>
      </div>

      <div className="same-style account-setting" >      
      { currentUser ? (           
        <button id="myaccount"
        className="account-setting-active mobile-aside-button"
        onClick={e => handleUserClick(e)}
        >
        <span className="login-circle">{currentUser.email.substring(0,1).toUpperCase()}
        </span>        
        </button>
        )
        : (
         <button id="myaccount"
          className="account-setting-active mobile-aside-button"
          onClick={e => handleUserClick(e)}
         >
         <i className="pe-7s-user" />
         <span className="title-style">{strings["login_signup"]}</span>
         </button>
        )
      }             
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>
      </div>
    </div>
    <div className="container-fluid same-style mobile-off-canvas d-block d-lg-none tab-style">
      <CategoryTab 
       />
    </div>  
    </div>
  );
};

IconGroup.propTypes = {
  products: PropTypes.array,
  cartData: PropTypes.array,
  //compareData: PropTypes.array,
  currency: PropTypes.object,
  iconWhiteClass: PropTypes.string,
  deleteFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
  enquiryData: PropTypes.array,
  strings: PropTypes.object
  //deleteAllFromWishlist: PropTypes.func
};

const mapStateToProps = state => {
  return {
    currency: state.currencyData,
    cartData: state.cartData,
    wishlistData: state.wishlistData,
    //compareData: state.compareData,
    enquiryData: state.enquiryData,
    products: state.productData.products
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteFromCart: (item, addToast) => {
      dispatch(deleteFromCart(item, addToast));
    },
    addToWishlist: (item) => {
      dispatch(addToWishlist(item));
    },    
    deleteAllFromWishlist: () => {
      dispatch(deleteAllFromWishlist());
    }    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(multilanguage(IconGroup));
